export const currencies = [{ title: "Việt Nam", value: 1 }];

export const regex = /^[0-9\b]+$/;
